export default __webpack_public_path__ + "static/media/verification.04006e43.png";